<!-- BEGIN #app -->
<div id="app" class="app"
  [ngClass]="{'app-sidebar-collapsed':app.sideBarCollapsed, 'app-sidebar-mobile-toggled': app.menuOpen, 'app-without-header': isWatchView}">
  <app-header *ngIf="!isWatchView" [showNavigation]="true"></app-header>
  <!--<app-navigation [collapse]="app.sideBarCollapsed"></app-navigation>-->
  <!-- BEGIN #sidebar -->
  <router-outlet></router-outlet>
  
</div>
<!-- END #app -->